export const LightBulbIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1794_3698)">
        <rect
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M54.5 26.5C54.5 25.5717 54.1313 24.6815 53.4749 24.0251C52.8185 23.3687 51.9283 23 51 23C50.0717 23 49.1815 23.3687 48.5251 24.0251C47.8687 24.6815 47.5 25.5717 47.5 26.5V30C47.5 30.9283 47.8687 31.8185 48.5251 32.4749C49.1815 33.1313 50.0717 33.5 51 33.5C51.9283 33.5 52.8185 33.1313 53.4749 32.4749C54.1313 31.8185 54.5 30.9283 54.5 30V26.5ZM70.7995 36.1495C71.4371 35.4894 71.7898 34.6053 71.7819 33.6876C71.7739 32.7699 71.4058 31.8921 70.7569 31.2431C70.1079 30.5942 69.2301 30.2261 68.3124 30.2181C67.3947 30.2102 66.5106 30.5629 65.8505 31.2005L63.376 33.675C62.7384 34.3351 62.3857 35.2192 62.3936 36.1369C62.4016 37.0546 62.7697 37.9324 63.4186 38.5814C64.0676 39.2303 64.9454 39.5984 65.8631 39.6064C66.7808 39.6143 67.6649 39.2616 68.325 38.624L70.7995 36.1495ZM79 51C79 51.9283 78.6313 52.8185 77.9749 53.4749C77.3185 54.1313 76.4283 54.5 75.5 54.5H72C71.0717 54.5 70.1815 54.1313 69.5251 53.4749C68.8688 52.8185 68.5 51.9283 68.5 51C68.5 50.0717 68.8688 49.1815 69.5251 48.5251C70.1815 47.8687 71.0717 47.5 72 47.5H75.5C76.4283 47.5 77.3185 47.8687 77.9749 48.5251C78.6313 49.1815 79 50.0717 79 51ZM33.675 38.624C33.9979 38.9583 34.3841 39.2249 34.8111 39.4084C35.2381 39.5918 35.6974 39.6883 36.1621 39.6924C36.6268 39.6964 37.0877 39.6079 37.5178 39.4319C37.948 39.2559 38.3388 38.996 38.6674 38.6674C38.996 38.3388 39.2559 37.948 39.4319 37.5178C39.6079 37.0877 39.6964 36.6268 39.6924 36.1621C39.6883 35.6974 39.5918 35.2381 39.4084 34.8111C39.2249 34.3841 38.9583 33.9979 38.624 33.675L36.1495 31.2005C35.4894 30.5629 34.6053 30.2102 33.6876 30.2181C32.7699 30.2261 31.8921 30.5942 31.2431 31.2431C30.5942 31.8921 30.2261 32.7699 30.2181 33.6876C30.2102 34.6053 30.5629 35.4894 31.2005 36.1495L33.675 38.624ZM33.5 51C33.5 51.9283 33.1313 52.8185 32.4749 53.4749C31.8185 54.1313 30.9283 54.5 30 54.5H26.5C25.5717 54.5 24.6815 54.1313 24.0251 53.4749C23.3687 52.8185 23 51.9283 23 51C23 50.0717 23.3687 49.1815 24.0251 48.5251C24.6815 47.8687 25.5717 47.5 26.5 47.5H30C30.9283 47.5 31.8185 47.8687 32.4749 48.5251C33.1313 49.1815 33.5 50.0717 33.5 51ZM44 72V68.5H58V72C58 73.8565 57.2625 75.637 55.9497 76.9497C54.637 78.2625 52.8565 79 51 79C49.1435 79 47.363 78.2625 46.0503 76.9497C44.7375 75.637 44 73.8565 44 72ZM58 65C58.0525 63.81 58.728 62.739 59.6695 61.9935C61.9539 60.1919 63.6203 57.7234 64.437 54.931C65.2537 52.1387 65.1803 49.1613 64.2268 46.4126C63.2734 43.664 61.4873 41.2807 59.1168 39.5939C56.7464 37.9072 53.9093 37.0008 51 37.0008C48.0907 37.0008 45.2536 37.9072 42.8832 39.5939C40.5127 41.2807 38.7266 43.664 37.7732 46.4126C36.8197 49.1613 36.7463 52.1387 37.563 54.931C38.3797 57.7234 40.0461 60.1919 42.3305 61.9935C43.2755 62.739 43.9475 63.81 43.9965 65H58.0035H58Z"
          fill="white"
        />
        <rect
          x="0.418153"
          y="0.418153"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1794_3698)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1794_3698"
          x="-21.744"
          y="-21.744"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1794_3698"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1794_3698"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1794_3698"
          x1="9.12934"
          y1="-9.36905e-07"
          x2="55.009"
          y2="61.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
